import axios from 'axios'
import * as Sentry from '@sentry/vue'

/**
 * For a `catch` that deliberately carries on (a background refresh, a
 * non-critical fetch). A failed request is already reported by the API client
 * (`services/api.ts`: 5xx → Sentry event, 4xx → breadcrumb), so only what
 * isn't an HTTP error — a bug in the code around the request — is sent here,
 * tagged with where it happened. Without this such a bug would vanish.
 */
export function reportError(err: unknown, where: string): void {
  if (axios.isAxiosError(err)) return
  Sentry.captureException(err, { tags: { where } })
}
